// 新版本提示：開頁時記下目前的 build，之後每 5 分鐘＋切回分頁時比對 /version.json，不同就提示重新整理
import { useEffect, useState } from "react";

const CHECK_INTERVAL_MS = 5 * 60 * 1000;

async function fetchBuild(): Promise<string | null> {
  try {
    const res = await fetch("/version.json", { cache: "no-store" });
    if (!res.ok) return null;
    return ((await res.json()) as { build?: string }).build ?? null;
  } catch {
    return null;
  }
}

export function useVersionCheck() {
  const [hasNewVersion, setHasNewVersion] = useState(false);

  useEffect(() => {
    let baseline: string | null = null;
    let stopped = false;
    void fetchBuild().then((b) => {
      baseline = b;
    });
    const check = async () => {
      const next = await fetchBuild();
      if (stopped || !next) return;
      if (!baseline) baseline = next;
      else if (next !== baseline) setHasNewVersion(true);
    };
    const onVisible = () => {
      if (document.visibilityState === "visible") void check();
    };
    const id = setInterval(check, CHECK_INTERVAL_MS);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      stopped = true;
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return { hasNewVersion, reload: () => window.location.reload() };
}
